import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import React from 'react'

const AnswerButton = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  ${ props => props.answered && css `
    cursor: default;
  `}
`

const AnswerLeft = styled.div`
  background: white;
  color: white;
  width: 70px;
  height: 70px;
  @media (min-width: 768px) {
    width: 150px;
    height: 150px;
  }

  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-right: -20px;
  z-index: 5;
  border: 2px solid ${props => props.colour};

  svg {
    font-size: 2.3rem;
    @media (min-width: 768px) {
      font-size: 5rem;
    }
  }
`

const AnswerLeftInner = styled.div`
  width: 50px;
  height: 50px;
  @media (min-width: 768px) {
    width: 125px;
    height: 125px;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  opacity: 0.5;
  transition: all 0.35s ease-in-out;
  background: ${props => props.colour};

  ${ props => props.selected && css `
    opacity: 1;
  `}

  ${ props => props.answered && css `
    opacity: 1;
  `}

  ${AnswerButton}:hover & {
    opacity: 1;
  }
`

const AnswerRight = styled.div`
  flex-grow: 1;
`

const AnswerText = styled.div`
  font-size: 1.1em;
  padding: .5rem .5rem .5rem 1rem;
  @media (min-width: 768px) {
    font-size: 1.6em;
    padding: 1rem 1rem 1rem 2rem
  }
  text-align: left;
  padding: 1rem;
  color: white;
  padding-left: 2rem;
  border-radius: 5px;
  background: ${props => props.colour};
  border: none;
`

const AnswerReveal = styled.div`
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 5px;
  font-size: .9em;
  @media (min-width: 768px) {
    font-size: 1.2em;
  }
  svg {
    font-size: 1.3rem;
    @media (min-width: 768px) {
      font-size: 1.8rem;
    }
    margin-right: 0.5rem;
  }
`

const AnswerSelected= styled.div`
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 5px;
  font-size: .9em;
  @media (min-width: 768px) {
    font-size: 1.2em;
  }
  svg {
    font-size: 1.3rem;
    @media (min-width: 768px) {
      font-size: 1.8rem;
    }
    margin-right: 0.5rem;
  }
`

export default class Answer extends React.Component {
  static propTypes = {
    answer: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    selected: PropTypes.bool,
    correct: PropTypes.bool,
    colour: PropTypes.string.isRequired
  }

  static defaultProps = {
    selected: false
  }

  buttonStyle (colour, correct, answered, hideQuestionFeedback, quizVisualStyle, selected) {
    if(quizVisualStyle == 'red_and_black') {
      if(answered && correct && selected && !hideQuestionFeedback) {
        return '#52aa5e'
      } else if(answered && !correct && selected && !hideQuestionFeedback) {
        return '#ee2e31'
      } else {
        return '#868686'
      }
    } else {
      if(!answered || (answered && correct) || hideQuestionFeedback) {
        switch(colour) {
          case 'a':
            return '#0090cb'
          case 'b':
            return '#ee2e31'
          case 'c':
            return '#52aa5e'
          case 'd':
            return '#d664be'
          case 'e':
            return '#373f51'
          case 'f':
            return '#372554'
        }
      } else {
        return 'gray'
      }
    }
  }

  render() {
    let {
      answer, answered, correct, onClick, selected, colour, hideQuestionFeedback, quizVisualStyle
    } = this.props

    let reaction = 'fas fa-smile'
    if(answered && selected && !correct) {
      reaction = 'fas fa-frown'
    } else if(answered && selected && correct) {
      reaction = 'fas fa-smile'
    }

    let buttonColour = this.buttonStyle(colour, correct, answered, hideQuestionFeedback, quizVisualStyle, selected)

    return (
        <AnswerButton
          selected={ selected }
          answered={ answered }
          onClick={() => { onClick() }}
        >
          <AnswerLeft colour={buttonColour}>
            <AnswerLeftInner
              colour={buttonColour}
              selected={selected}
              answered={answered}
            >
              { selected ? (<div><i className="fas fa-check"></i></div>) : null }
            </AnswerLeftInner>
          </AnswerLeft>
          <AnswerRight>
            <AnswerReveal>
              {
                correct === true && !hideQuestionFeedback
                  ? (
                    <React.Fragment>
                      <i className="fas fa-check"></i> <span>Correct</span>
                    </React.Fragment>
                  )
                  : (<React.Fragment>&nbsp;</React.Fragment>)
              }
            </AnswerReveal>
            <AnswerText colour={buttonColour}>
              { answer }
            </AnswerText>
            <AnswerSelected>
              {
                answered && selected && !hideQuestionFeedback
                ? (
                  <React.Fragment>
                    <i className={reaction}></i> <span>Your Answer</span>
                  </React.Fragment>
                )
                : (<React.Fragment>&nbsp;</React.Fragment>)
              }
            </AnswerSelected>
          </AnswerRight>
        </AnswerButton>
    )
  }
}
